import type { Panel } from '@atlassian/preview-panels-api';

export const isNativeIssueViewPreviewPanel = (panel: Panel) => {
	return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};
